var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTotalPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_7430",
    "data-name": "Group 7430",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 26.161,
    height: 13.185,
    viewBox: "0 0 26.161 13.185",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1998",
    "data-name": "Rectangle 1998",
    width: 26.161,
    height: 13.185
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5370",
    "data-name": "Group 5370",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7750",
    "data-name": "Path 7750",
    d: "M26.147,11.407a13.187,13.187,0,0,0-26.132,0,1.6,1.6,0,0,0,1.607,1.779H24.54a1.6,1.6,0,0,0,1.607-1.779M15.4,10.149a2.141,2.141,0,1,1-2.881-2.881l5.9-3.019Z",
    transform: "translate(0 0)"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalPurple);
export default __webpack_public_path__ + "static/media/total-purple.040d58cac0ce61c9610d1991b28b91de.svg";
export { ForwardRef as ReactComponent };